import { render, staticRenderFns } from "./BasePhysic.vue?vue&type=template&id=ac3288e0&"
import script from "./BasePhysic.vue?vue&type=script&lang=js&"
export * from "./BasePhysic.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports